import { throttle } from 'throttle-debounce';
import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducer';
import { loadState, saveState } from './localStorage';
import { dispatchMiddleware } from './middleware';

const composeEnhancers =
  // eslint-disable-next-line no-underscore-dangle
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? // eslint-disable-next-line no-underscore-dangle
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const enhancer = composeEnhancers(applyMiddleware(thunk, dispatchMiddleware));

export const store = createStore(reducer, loadState(), enhancer);

store.subscribe(
  throttle(500, () => {
    saveState({
      ...store.getState()
    });
  })
);

export default store;

// export const store = {};
// export default store;
